

















import { SelectInput } from '@bambeehr/pollen';
import { computed } from '@nuxtjs/composition-api';
import useRegistration, {
  RegistrationStateNames,
} from '@/modules/SelfServiceRegistration/hooks/useRegistration';
import useMatchMedia from '@/hooks/useMatchMedia';
import { BSideReasonOptions } from '@/modules/HomePage/bside/constants';

export default {
  components: {
    SelectInput,
  },
  props: {
    dropdownLabel: {
      type: String,
      default: 'What brought you to Bambee?',
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Choose your reason',
    },
    inputSize: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { state, updateRegistration } = useRegistration();
    // The v3 reason list; the B-side is the only homepage (BIO-2166).
    const reasonOptions = BSideReasonOptions;
    const bambeeRefferral = computed(
      () => state[RegistrationStateNames.WHAT_BROUGHT_YOU_TO_BAMBEE]
    );
    const matchMedia = useMatchMedia();
    const isLarge = computed(() => matchMedia.value.sm || matchMedia.value.xs);
    const size = computed(() => {
      let input;
      if (props.inputSize) {
        input = props.inputSize;
      } else {
        input = !isLarge.value ? 'large' : 'normal';
      }

      return input;
    });

    const handleInput = (input) => {
      updateRegistration({
        [RegistrationStateNames.WHAT_BROUGHT_YOU_TO_BAMBEE]: input,
      });
      emit('input', input);
    };

    return {
      handleInput,
      bambeeRefferral,
      isLarge,
      reasonOptions,
      size,
    };
  },
};
